<template>
  <main>
    <div class="title-box">
      <span style="font-size: 32px; font-weight: 400; ">资源包套餐</span>
      <span style="margin-left: 10px; margin-right: 10px; color: #ccc;">|</span>
      <el-link type="primary" @click="gotoIndex()">返回首页</el-link>
    </div>

    <div class="tip-box">
      <div>
        <span style="font-size: 20px; color: #3888d7; font-weight: 800; padding-right: 6px;">|</span>
        <span style="font-size: 18px; font-weight: bold;">购买须知</span>
      </div>
      <div style="margin-top: 16px;">
        <span class="tip-tab">使用说明</span>
        <span class="tip-content">当您资源包耗尽时，服务将面临不可用风险，为保证业务不受影响，请及时在此页面购买预付费资源包或前往控制台设置页开通后付费模式。</span>
      </div>
      <div style="margin-top: 16px;">
        <span class="tip-tab">退订规则</span>
        <span class="tip-content">资源包购买后不支持退款及剩余次数冻结。</span>
      </div>
    </div>

    <div class="tip-box" style="margin-top: 40px;">
      <div>
        <span style="font-size: 20px; color: #3888d7; font-weight: 800; padding-right: 6px;">|</span>
        <span style="font-size: 18px; font-weight: bold;">配置选择</span>
      </div>
    </div>

    <div class="product-box">
      <div class="resource-box" style="margin-top: 20px;">
        <div class="tip-label">资源包</div>

        <div class="resource-package-box">
          <div v-for="param in params" :key="param.no" :class="selectedNo === param.no ? 'resource-package-box-1-selected': 'resource-package-box-1'" @click="handleSelect(param)">
            <div :class="selectedNo === param.no ? 'resource-package-box-2-selected': 'resource-package-box-2'">
              <div class="resource-package-desc">
                <div class="resource-package-title">{{param.name}} </div>
<!--                <div class="resource-package-title">{{param.name}}/{{param.duration}}{{param.unit}} </div>-->
<!--                <div class="resource-package-valid-date">{{param.spec}}，套餐有效期为{{param.duration}}{{param.unit}}，每月最后一天清零</div>-->
                <div class="resource-package-valid-date">{{param.spec}}</div>
              </div>
              <div class="resource-package-price">{{ formattedPrice(param.unitPrice/100) }}元</div>
            </div>
          </div>

        </div>
      </div>

      <div style="margin-top: 20px;">
        <span class="tip-label">License数量</span>
        <span><el-input-number @change="handleChange" v-model="licenseCount" :min="0" :step="10"></el-input-number></span>
        <span style="margin-left: 4px; color:#999; font-size: 13px;">个</span>
      </div>

      <div v-if="selectedParam.unit === '月'" style="margin-top: 20px;">
        <span class="tip-label">有效期限</span>
        <span><el-input-number @change="handleChange" v-model="duration" :min="1" :step="1"></el-input-number></span>
        <span style="margin-left: 4px; color:#999; font-size: 13px;">月（有效期自购买之日{{duration}}月内有效）</span>
      </div>

      <div style="margin-top: 20px;">
        <span class="tip-label">协议条款</span>
        <span class="tip-label" style="width: 50vw;">
          <el-checkbox v-model="checked" style="color: #666; font-size: 14px;">我已阅读并同意</el-checkbox>
<!--          <el-link type="primary" style="margin-top: -2px; font-size: 14px;">《大模型服务条款》</el-link>-->
          <a target="_blank" href="/static/agreements/user_agreement_v1.HTML" style="">《服务条款》</a>
        </span>
      </div>
    </div>

    <div class="pay-box">
      <span>结算费用</span>
      <span class="total-price">{{formattedPrice(settlementAmount/100)}}元</span>
      <el-button type="primary" :disabled="!checked || settlementAmount < 0.01" @click="handleBuy">立即购买</el-button>
    </div>
  </main>
</template>

<script>
import {mapState} from 'vuex'

import {
  reqResourcePicParams
} from '@/api'

export default {
  name: 'ResourcePackage4Pic',
  data() {
    return {
      params: [],
      licenseCount: 0,
      duration: 1,
      settlementAmount: 0,
      selectedNo: 0,  // 选中的套餐编号
      selectedParam: {},  // 选中的套餐
      productKey: this.$route.query.productKey, // 产品编号
      checked: false
    }
  },

  async mounted() {
    await this.getParams()
  },

  methods: {

    async getParams () {
      const result = await reqResourcePicParams()
      if (result.code === 0) {
        this.params = result.data
      } else {
        this.$message.error('套餐数据查询失败，请稍后再试')
      }
    },

    handleSelect (param) {
      this.selectedNo = param.no
      this.selectedParam = param
      this.handleChange()
    },

    gotoIndex () {
      this.$router.push({
        path: '/index'
      })
    },

    handleChange (value) {
      this.settlementAmount = this.selectedParam.unitPrice * this.licenseCount * this.duration
    },

    async handleBuy () {
      let orderConfirmWrapper = this.selectedParam
      orderConfirmWrapper.licenseCount = this.licenseCount
      orderConfirmWrapper.settlementAmount = this.settlementAmount
      orderConfirmWrapper.productKey = this.productKey

      if (this.selectedParam.unit === '月') {
        orderConfirmWrapper.duration = this.duration
      }

      orderConfirmWrapper.purchaseType = 1
      orderConfirmWrapper.resType = 1 //1-图像 2-token
      await this.$store.dispatch('setOrderConfirmWrapper', {orderConfirmWrapper})

      this.$router.push({
        path: '/orderConfirm',
        query: {productKey: this.productKey}
      }).catch(err=>{})
    },

    formattedPrice (price) {
      return parseFloat(price).toFixed(2); // 保留两位小数
    }
  },

  computed: {
    ...mapState(['courses']),

  }

}
</script>

<style scoped>

  main {
    height: 100vh;
    display: flex;
    flex-direction: column;
    padding-left: 50px;
  }

  .title-box {
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .tip-box {
    display: flex;
    flex-direction: column;
  }

  .tip-tab {
    font-size: 13px;
    padding: 6px 10px;
    color: #666;
    background-color: rgba(243, 243, 243, 0.9);
    margin-right: 20px;
  }

  .tip-content {
    font-size: 14px;
    color: #666;
  }

  .product-box {
    display: flex;
    flex-direction: column;
  }

  .resource-box {
    display: flex;
    flex-direction: row;
  }

  .tip-label {
    font-size: 14px;
    color: #666;
    width: 10vw;
  }

  .resource-package-box {
    display: flex;
    flex-direction: column;
  }

  .resource-package-box-1 {
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
  }

  .resource-package-box-1:hover {
    border: solid 2px #409EFF;
  }

  .resource-package-box-1-selected {
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
    border: solid 2px #FF9933;
  }

  .resource-package-box-2 {
    display: flex;
    flex-direction: row;
    width: 50vw;
    padding-left: 24px;
    padding-top: 24px;
    padding-bottom: 24px;
    border: solid 1px #999;
    /*border-right: dashed 1px #999;*/
  }

  .resource-package-box-2-selected {
    display: flex;
    flex-direction: row;
    width: 50vw;
    padding-left: 24px;
    padding-top: 24px;
    padding-bottom: 24px;
  }

  .resource-package-desc {
    display: flex;
    flex-direction: column;
    width: 45vw;
  }

  .resource-package-title {
    font-size: 16px;
    font-weight: 500;
    line-height: 26px;
  }

  .resource-package-valid-date {
    font-size: 12px;
    color: #666;
    line-height: 26px;
  }

  .resource-package-price {
    display: flex;
    justify-content: right;
    padding-top: 4px;
    font-size: 18px;
    font-weight: bold;
    color: #EF6234;
    text-align: right;
    width: 7vw;
    padding-right: 25px;
  }

  .resource-package-amount {
    border-top: solid 1px #999;
    border-bottom: solid 1px #999;
    border-right: solid 1px #999;
    padding: 25px;
  }

  /*.resource-package-amount:hover {*/
  /*  border-top: solid 2px #409EFF;*/
  /*  border-bottom: solid 2px #409EFF;*/
  /*  border-right: solid 2px #409EFF;*/
  /*}*/

  .pay-box {
    margin-top: 50px;
    padding-bottom: 50px;
    width: 90vw;
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: right;
    align-items: end;
  }

  .total-price {
    margin-left: 16px;
    margin-right: 20px;
    font-size: 22px;
    font-weight: bold;
    color: #EF6234;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ResourcePackage/ResourcePackage4Pic.vue